import React from "react";
import NumberFormat from "react-number-format";

class Input extends React.Component {
  static defaultProps = {
    type: "text",
    value: "",
    placeholder: "",
    prefix: "",
    addCommas: false,
    className: ""
  };
  constructor() {
    super();

    let sep = ",";
    const a = 1000;

    if (a.toLocaleString().indexOf(".") !== -1) {
      sep = ".";
    }

    this.state = {
      sep
    };
  }
  onChange = e => {
    this.props.onChange({
      name: this.props.name,
      value: e.target.value
    });
  };
  onChangeNumber = ({ value }) => {
    this.props.onChange({
      name: this.props.name,
      value
    });
  };
  render() {
    const props = this.props;
    const state = this.state;

    if (props.addCommas) {
      const addCommasProps = {
        prefix: props.prefix,
        thousandSeparator: state.sep,
        decimalSeparator: state.sep === "," ? "." : ",",
        value: props.value,
        onValueChange: this.onChangeNumber,
        className: props.className,
      }
      return <NumberFormat {...addCommasProps} />;
    }

    const _props = {
      onChange: this.onChange,
      className: props.className,
      required: true,
      name: props.name,
      placeholder: props.placeholder,
      type: props.type,
      value: props.value
    };

    return <input {..._props} />;
  }
}

export default Input;
